import angular from 'angular';

import './controller';

export const BRAND_NAME = document.getElementById("BRAND_NAME")?.textContent
export const BROCHURE_BASE_URL = document.getElementById("BROCHURE_BASE_URL")?.textContent
export const HELP_BASE_URL = document.getElementById("HELP_BASE_URL")?.textContent
export const MERCHANT_PORTAL_API_BASE_URL = document.getElementById("MERCHANT_PORTAL_API_BASE_URL")?.textContent
export const CONSUMER_BASE_URL = document.getElementById("CONSUMER_BASE_URL")?.textContent
export const GOOGLEMAPS_API_KEY = document.getElementById("GOOGLEMAPS_API_KEY")?.textContent
export const POS_API_BASE_URL = document.getElementById("POS_API_BASE_URL")?.textContent
export const LAUNCH_DARKLY_CLIENT_SIDE_ID = document.getElementById("LAUNCH_DARKLY_CLIENT_SIDE_ID")?.textContent
export const AMPLITUDE_CLIENT_SIDE_ID = document.getElementById("AMPLITUDE_CLIENT_SIDE_ID")?.textContent
export const ADWORDS_ID = document.getElementById("ADWORDS_ID")?.textContent
export const MAP_URL = "https://www.google.com/maps/embed/v1/place?key="
export const MERCHANT_PORTAL_OKTA_CLIENT_ID = document.getElementById("MERCHANT_PORTAL_OKTA_CLIENT_ID")?.textContent
export const MERCHANT_PORTAL_OKTA_ISSUER = document.getElementById("MERCHANT_PORTAL_OKTA_ISSUER")?.textContent
export const AU_MERCHANT_HUB_URL = document.getElementById("AU_MERCHANT_HUB_URL")?.textContent
export const US_MERCHANT_HUB_URL = document.getElementById("US_MERCHANT_HUB_URL")?.textContent
export const EU_MERCHANT_HUB_URL = document.getElementById("EU_MERCHANT_HUB_URL")?.textContent

const Environment = {
    BRAND_NAME,
    BROCHURE_BASE_URL,
    HELP_BASE_URL,
    MERCHANT_PORTAL_API_BASE_URL,
    CONSUMER_BASE_URL,
    GOOGLEMAPS_API_KEY,
    POS_API_BASE_URL,
    LAUNCH_DARKLY_CLIENT_SIDE_ID,
    AMPLITUDE_CLIENT_SIDE_ID,
    ADWORDS_ID,
    MAP_URL,
    MERCHANT_PORTAL_OKTA_CLIENT_ID,
    MERCHANT_PORTAL_OKTA_ISSUER,
    AU_MERCHANT_HUB_URL,
    US_MERCHANT_HUB_URL,
    EU_MERCHANT_HUB_URL
}

export default Environment

angular.module("core.application.main")
    .constant("core.application.main.controller.environment", Environment);
